// Load Google Font (only in browser)
if (typeof document !== 'undefined') {
  const trollhattanLightFont = document.createElement('link');
  trollhattanLightFont.rel = 'stylesheet';
  trollhattanLightFont.href = 'https://fonts.googleapis.com/css2?family=Barlow:wght@100..900&display=swap';
  document.head.appendChild(trollhattanLightFont);
}

export const trollhattanLight = {
  name: 'trollhattan:light',
  extends: 'citizen:light',
  cssPath: 'custom/styles/tro/trollhattan-light.theme',
  vuetify: {
    defaults: {
      HItemCard: {
        HScopedItemCardActionBtn: {
          color: 'secondary',
          variant: 'flat',
        },
      },
      HSearchItemsResults: {
        HItemCard: {
          HScopedItemCardActionBtn: {
            color: 'secondary',
            variant: 'flat',
          },
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        primary: '#4B2D78',
        'on-primary': '#FFFFFF',
        'primary-lighten-1': '#6B4BA0',
        'primary-lighten-2': '#8C6FC2',
        'primary-lighten-3': '#D2C3FF',
        'primary-darken-1': '#3A225E',
        secondary: '#19C896',
        'on-secondary': '#FFFFFF',
        'secondary-lighten-1': '#64DCBE',
        'secondary-darken-1': '#0D9B73',
        'search-list-hover': '#E5DEFF',
        error: '#B00020',
        'on-error': '#FFFFFF',
        'error-lighten-1': '#E57373',
        'error-lighten-2': '#FFCDD2',
        'on-error-lighten-2': '#292929',
        'error-lighten-3': '#FFB4D2',
        success: '#19C896',
        'on-success': '#FFFFFF',
        'success-lighten-1': '#64DCBE',
        warning: '#CB6300',
        'on-warning': '#FFFFFF',
        'warning-lighten-1': '#FFA000',
        'warning-lighten-2': '#FFE082',
        'warning-lighten-3': '#FFF8E1',
        surface: '#FFFFFF',
        'on-surface': '#292929',
        'surface-variant': '#E5DEFF',
        'on-surface-variant': '#4B2D78',
        background: '#F0F0F0',
        'on-background': '#292929',
        'background-3': '#F8F6FF',
        'on-background-3': '#292929',
        'background-4': '#FFFFFF',
        'on-background-4': '#292929',
        black: '#292929',
        'on-black': '#FFFFFF',
        'black-lighten-1': '#333333',
        gray: '#605d62',
        'gray-lighten-1': '#79767a',
        'gray-lighten-2': '#F0F0F0',
        white: '#FFFFFF',
        'white-darken-1': '#EBE6E0',
        red: '#EB5F5F',
        'on-red': '#FFFFFF',
        cyan: '#00B9FF',
        'on-cyan': '#292929',
        yellow: '#F0FA5A',
        'on-yellow': '#292929',
        'badge-disabled': '#F0F0F0',
        'on-badge-disabled': '#605d62',
        'badge-primary': '#4B2D78',
        'on-badge-primary': '#FFFFFF',
        'badge-secondary': '#D2C3FF',
        'on-badge-secondary': '#292929',
        'badge-tertiary': '#F0FA5A',
        'on-badge-tertiary': '#292929',
        green: '#19C896',
        skog: '#4B2D78',
        'on-skog': '#FFFFFF',
        strand: '#D2C3FF',
        'on-strand': '#4B2D78',
        'strand-lighten-1': '#FFFFFF',
        'strand-lighten-2': '#F0F0F0',
        disabled: '#F0F0F0',
        'on-disabled': '#605d62',
        loader: '#4B2D78',
        'loader-background': '#E0E3E1',
        'text-color-primary': '#292929',
        'text-color-secondary': '#41474D',
        fullmakter: '#FFFFFF',
        ovriga: '#FFFFFF',
        utbildning: '#FFFFFF',
        omsorg: '#FFFFFF',
        forening: '#FFFFFF',
        adshavare: '#FFFFFF',
        foretag: '#00000000',
        'on-foretag': '#FFFFFF',
        fastigheter: '#00000000',
        'on-fastigheter': '#FFFFFF',
        'sector-privat': '#64DCBE',
        'sector-företag': '#FFB4D2',
        'on-sector-privat': '#292929',
        'on-sector-företag': '#292929',
        'start-page': '#4B2D78',
        'on-start-page': '#FFFFFF',
        'bulletin-board': '#D2C3FF',
        'on-bulletin-board': '#4B2D78',
        scrollbar: '#4B2D78',
        toolbar: '#283E49',
        'on-toolbar': '#FFFFFF',
        'breadcrumb-hover': '#D2C3FF',
        'on-breadcrumb': '#FFFFFF',

        'process-state-active': '#CB6300',
        'on-process-state-active': '#FFFFFF',
        'process-state-inactive': '#F0F0F0',
        'on-process-state-inactive': '#888888',
        'process-state-done': '#19C896',
        'on-process-state-done': '#FFFFFF',
        'process-state-error': '#EB5F5F',
        'on-process-state-error': '#FFFFFF',
        'process-state-skipped': '#7DE1FF',
        'on-process-state-skipped': '#292929',

        'bulletin-informational': '#FAFAFA',
        'on-bulletin-informational': '#292929',
        'bulletin-warning': '#FFFABE',
        'on-bulletin-warning': '#292929',
        'bulletin-critical': '#EB5F5F',
        'on-bulletin-critical': '#FFFFFF',
        'bulletin-skipped': '#D2C3FF',
        'on-bulletin-skipped': '#4B2D78',

        'header-button': '#D2C3FF',
        'on-header-button': '#292929',
        'dialog-header-button': '#292929',
        'focus-ring': '#00B9FF',

        // Page header background colors
        'page-companies-header-bg': '#00000000',
        'on-page-companies-header-bg': '#FFFFFF',
        'page-properties-header-bg': '#00000000',
        'on-page-properties-header-bg': '#FFFFFF',
        'page-authorizations-header-bg': '#FFFFFF',
        'on-page-authorizations-header-bg': '#292929',
        'page-children-header-bg': '#FFFFFF',
        'on-page-children-header-bg': '#292929',
        'page-enrollments-header-bg': '#FFFFFF',
        'on-page-enrollments-header-bg': '#292929',
        'page-employments-header-bg': '#FFFFFF',
        'on-page-employments-header-bg': '#292929',
        'page-eservices-header-bg': '#FFFFFF',
        'on-page-eservices-header-bg': '#292929',
        'page-cases-header-bg': '#FFFFFF',
        'on-page-cases-header-bg': '#292929',

        // Item card border colors
        'card-company': '#FFB4D2',
        'card-property': '#EB5F5F',
        'card-authorization': '#FFFFFF',
        'card-child': '#FFFFFF',
        'card-enrollment': '#FFFFFF',
        'card-employment': '#FFFFFF',
        'card-case': '#19C896',
        'card-eservice': '#4B2D78',
        'card-facility': '#D2C3FF',
        'card-berth': '#6B4BA0',
        'card-servingpermit': '#EB5F5F',
        'card-servingplace': '#8C6FC2',
        'card-salespermit': '#FFB4D2',
        'card-salespoint': '#19C896',
        'card-association': '#8C8C8C',

        // Chips
        'chip-active': '#4B2D78',
        'on-chip-active': '#FFFFFF',
      },
    },
  },
};
